<script>
import Head from '@/components/Head';
import Table from '@/components/Table';
import Button from '@/components/Button';
import Input from '@/components/Input';
import Select from '@/components/Select';
import Loader from '@/components/Loader';
import SimpleModal from '@/components/SimpleModal';
import { toast } from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';
import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';

export default {
    data() {
        return {
            previousDebts: 0,
            totalBonusValue: 0,
            loader: true,
            loadingTable: true,
            hasNextPage: false,
            itemsPerPage: 10,
            actualPage: 0,
            totalItems: 0,
            associateTableCategories: [
                'ID',
                'Meio do crédito',
                'Tipo de pagamento',
                'Data do crédito',
                'Contribuição',
                'Taxa de adesão',
                'Honorários',
                'Encargos',
                'Total',
                'Observações',
            ],
            associatesTableActions: [
                'pencil-square',
                'trash',
            ],
            totalSumPayments: 0,
            totalCreditValue: 0,
            totalCreditValueMonthly: 0,
            totalCreditValueSemiannual: 0,
            totalCreditValueAnnual: 0,
            totalMembershipFee: 0,
            totalCharges: 0,
            totalFees: 0,
            totalRefundTransfer: 0,
            financial_situation: '',
            financial_situation_description: '',
            associate_name: '',
            associate_cpf: '',
            payments: [],
            paymentsFullInfos: [],
            modalConfirmDelete: false,
            modalAddPayment: false,
            modalEditPayment: false,
            modalFinancialSpreadsheet: false,
            installments: [],
            loadingInstallments: false,
            selectedPaymentToDelete: null,
            selectedPaymentToEdit: null,
            selectedAssociateToDelete: null,
            addPaymentData: {
                payment_method: '',
                payment_type: 'Mensalidade',
                payment_date: '',
                credit_value: '',
                membership_fee: '',
                charges: '',
                fees: '',
                refund_transfer: '',
                comments: '',
                transferred_to_user_id: null,
                installment_id: null, // ID da parcela vinculada
            },
            linkedUserInfo: null,
            transferUserSelect: [
                { name: 'Não transferir', value: null }
            ],
            editPaymentData: {
                id: null,
                payment_method: '',
                payment_type: '',
                payment_date: '',
                credit_value: '',
                membership_fee: '',
                charges: '',
                fees: '',
                refund_transfer: '',
                comments: '',
                is_previous_debt: 'Não',
                previous_debt_amount: '',
            },
            isPreviousDebtSelect: [
                { name: 'Não', value: 'Não' },
                { name: 'Sim', value: 'Sim' }
            ],
            filtersData: {
                initial_date: '2019-11-28',
                finish_date: this.getCurrentDate(),
            },
            paymentTypeSelect: [
                {
                    name: 'Mensalidade',
                    value: 'Mensalidade',
                    selected: true
                },
                {
                    name: 'Semestralidade',
                    value: 'Semestralidade',
                    selected: false
                },
                {
                    name: 'Anuidade',
                    value: 'Anuidade',
                    selected: false
                },
            ],
        }
    },
    props: {
        userData: {
            type: Object
        }
    },
    created() {
        if (this.userData.role == 'associate') {
            this.$router.push('/inicio');
        }

        this.getNextPayment();
        this.loadAllAssociatesForTransfer();
    },
    methods: {
                calculateTotalBonus() {
                    // Soma o campo bonus_discount de todos os pagamentos
                    let total = 0;
                    this.paymentsFullInfos.forEach(payment => {
                        if (payment.bonus_discount) {
                            total += parseFloat(payment.bonus_discount);
                        }
                    });
                    this.totalBonusValue = total;
                },
        notify(text, type) {
            toast(text, {
                "type": type == 'info' ? 'info' : type == 'warning' ? 'warning' : type == 'error' ? 'error' : type == 'success' ? 'success' : 'default',
            });
        },
        exportFinancialPDF() {
            const doc = new jsPDF();
            
            // Cabeçalho
            doc.setFontSize(16);
            doc.text('ANIPP - Vida Financeira do Associado', 105, 15, { align: 'center' });
            
            doc.setFontSize(12);
            doc.text(`Associado: ${this.associate_name}`, 14, 25);
            doc.text(`CPF: ${this.associate_cpf}`, 14, 32);
            doc.text(`Status: ${this.financial_situation}`, 14, 39);
            
            if (this.financial_situation != 'Adimplente') {
                doc.text(`Descrição: ${this.financial_situation_description}`, 14, 46);
            }
            
            // Linha separadora
            const startY = this.financial_situation != 'Adimplente' ? 52 : 45;
            doc.setLineWidth(0.5);
            doc.line(14, startY, 196, startY);
            
            // Tabela de pagamentos
            const tableData = this.paymentsFullInfos.map(payment => [
                payment.id,
                payment.mean_of_credit,
                payment.payment_type,
                new Date(payment.payment_date).toLocaleDateString('pt-BR'),
                `R$ ${parseFloat(payment.credit_value || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}`,
                `R$ ${parseFloat(payment.membership_fee || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}`,
                `R$ ${parseFloat(payment.fees || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}`,
                `R$ ${parseFloat(payment.charges || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}`,
                `R$ ${parseFloat(payment.total || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}`,
            ]);
            
            autoTable(doc, {
                startY: startY + 5,
                head: [['ID', 'Meio', 'Tipo', 'Data', 'Contribuição', 'Taxa', 'Honorários', 'Encargos', 'Total']],
                body: tableData,
                theme: 'striped',
                headStyles: { fillColor: [41, 128, 185] },
                styles: { fontSize: 8, cellPadding: 2 },
                columnStyles: {
                    0: { cellWidth: 15 },
                    1: { cellWidth: 25 },
                    2: { cellWidth: 25 },
                    3: { cellWidth: 22 },
                    4: { cellWidth: 22 },
                    5: { cellWidth: 18 },
                    6: { cellWidth: 22 },
                    7: { cellWidth: 20 },
                    8: { cellWidth: 22 },
                },
            });
            
            // Totais
            const finalY = doc.lastAutoTable.finalY + 10;
            doc.setFontSize(10);
            doc.text(`Total Mensalidades: R$ ${parseFloat(this.totalCreditValueMonthly).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}`, 14, finalY);
            doc.text(`Total Semestralidades: R$ ${parseFloat(this.totalCreditValueSemiannual).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}`, 14, finalY + 6);
            doc.text(`Total Anuidades: R$ ${parseFloat(this.totalCreditValueAnnual).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}`, 14, finalY + 12);
            doc.text(`Total Taxas de Adesão: R$ ${parseFloat(this.totalMembershipFee).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}`, 14, finalY + 18);
            doc.text(`Total Honorários: R$ ${parseFloat(this.totalFees).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}`, 14, finalY + 24);
            doc.text(`Total Encargos: R$ ${parseFloat(this.totalCharges).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}`, 14, finalY + 30);
            
            doc.setFontSize(12);
            doc.setFont(undefined, 'bold');
            doc.text(`TOTAL GERAL: R$ ${parseFloat(this.totalSumPayments).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}`, 14, finalY + 40);
            
            // Rodapé
            doc.setFontSize(8);
            doc.setFont(undefined, 'normal');
            const pageCount = doc.internal.getNumberOfPages();
            for (let i = 1; i <= pageCount; i++) {
                doc.setPage(i);
                doc.text(`Gerado em: ${new Date().toLocaleString('pt-BR')}`, 14, 285);
                doc.text(`Página ${i} de ${pageCount}`, 196, 285, { align: 'right' });
            }
            
            // Salvar PDF com nome do associado
            const associateName = this.associate_name.replace(/[^a-zA-Z0-9]/g, '_');
            const fileName = `vida_financeira_${associateName}_${new Date().toISOString().split('T')[0]}.pdf`;
            doc.save(fileName);
            
            this.notify('PDF exportado com sucesso!', 'success');
        },
        exportFinancialSpreadsheet() {
            this.modalFinancialSpreadsheet = true;
            this.loadingInstallments = true;

            // Busca as parcelas geradas automaticamente
            this.$axios.get(`/installments/associate/${this.$route.params.id}`)
            .then(res => {
                this.installments = res.data.data.installments;
                this.loadingInstallments = false;
            })
            .catch(err => {
                this.notify('Erro ao carregar planilha financeira!', 'error');
                this.loadingInstallments = false;
            });
        },
        closeFinancialSpreadsheetModal() {
            this.modalFinancialSpreadsheet = false;
            this.installments = [];
        },
        getMonthName(date) {
            const months = ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 
                          'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'];
            const d = new Date(date);
            return months[d.getMonth()];
        },
        formatDate(date) {
            return new Date(date).toLocaleDateString('pt-BR');
        },
        formatCurrency(value) {
            return parseFloat(value || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2 });
        },
        loadLinkedUserInfo(userId) {
            console.log('Carregando usuário vinculado ID:', userId);
            this.$axios.get(`/user/${userId}`)
            .then(res => {
                console.log('Resposta do usuário vinculado:', res.data);
                if (res.data.data && res.data.data.user) {
                    this.linkedUserInfo = res.data.data.user;
                    console.log('linkedUserInfo configurado:', this.linkedUserInfo);
                }
            })
            .catch(err => {
                console.log('Erro ao carregar usuário vinculado:', err);
            });
        },
        loadAllAssociatesForTransfer() {
            console.log('Carregando todos os associados para transferência');
            this.$axios.get('/associates/get-all-active')
            .then(res => {
                console.log('Associados carregados:', res.data);
                if (res.data.data) {
                    // Monta o array de opções, excluindo o associado atual
                    const currentAssociateId = parseInt(this.$route.params.id);
                    const options = [{ name: 'Não transferir', value: null }];
                    
                    res.data.data.forEach(associate => {
                        // Não inclui o próprio associado na lista
                        if (associate.id !== currentAssociateId) {
                            options.push({
                                name: `${associate.name} - CPF: ${associate.document_cpf}`,
                                value: associate.id
                            });
                        }
                    });
                    
                    this.transferUserSelect = options;
                    console.log('transferUserSelect atualizado:', this.transferUserSelect);
                }
            })
            .catch(err => {
                console.log('Erro ao carregar associados:', err);
                // Mantém pelo menos a opção padrão
                this.transferUserSelect = [{ name: 'Não transferir', value: null }];
            });
        },
        getStatusClass(installment) {
            const today = new Date();
            const dueDate = new Date(installment.payment_date);
            
            if (installment.credit_value > 0) {
                return 'status-paid';
            } else if (dueDate < today) {
                return 'status-overdue';
            } else {
                return 'status-pending';
            }
        },
        getStatusText(installment) {
            const today = new Date();
            const dueDate = new Date(installment.payment_date);
            
            if (installment.credit_value > 0) {
                return 'Pago';
            } else if (dueDate < today) {
                return 'Vencido';
            } else {
                return 'Pendente';
            }
        },
        deletePayment() {
            this.loader = true;
            this.$axios.delete(`/payments/${this.selectedPaymentToDelete.id}`)
            .then(res => {
                this.notify('Pagamento deletado com sucesso!', 'success');

                setTimeout(() => {
                    window.location.reload();
                }, 2000);
            })
            .catch(err => {
                this.notify('Ocorreu um erro ao deletar um pagamento!', 'error');

                this.loader = false;
            });
        },
        getCurrentDate() {
            var data = new Date();

            var year = data.getFullYear();
            var monthly = ('0' + (data.getMonth() + 1)).slice(-2);
            var day = ('0' + data.getDate()).slice(-2);

            var formatedDate = year + '-' + monthly + '-' + day;
            return formatedDate;
        },
        paymentsTableClickAction(event) {
            if (event.eventType == 'pencil-square') {
                for (let i = 0; i < this.paymentsFullInfos.length; i++) {
                    if (this.paymentsFullInfos[i].id === event.data[0]) {
                        this.editPaymentData = {
                            id: this.paymentsFullInfos[i].id,
                            payment_method: this.paymentsFullInfos[i].payment_method,
                            payment_type: this.paymentsFullInfos[i].payment_type,
                            payment_date: this.paymentsFullInfos[i].payment_date,
                            credit_value: this.paymentsFullInfos[i].credit_value,
                            membership_fee: this.paymentsFullInfos[i].membership_fee,
                            charges: this.paymentsFullInfos[i].charges,
                            fees: this.paymentsFullInfos[i].fees,
                            refund_transfer: this.paymentsFullInfos[i].refund_transfer || 0,
                            comments: this.paymentsFullInfos[i].comments,
                        };
                    }
                }

                this.modalEditPayment = true;
            }

            if (event.eventType == 'trash') {
                console.log(event.data)
                for (let i = 0; i < this.paymentsFullInfos.length; i++) {
                    if (this.paymentsFullInfos[i].id === event.data[0]) {
                        this.selectedPaymentToDelete = {
                            id: this.paymentsFullInfos[i].id,
                            user_id: this.paymentsFullInfos[i].user_id
                        }
                    }
                }

                this.modalConfirmDelete = true;
            }
        },
        getNextPaymentFilter() {
            this.loadingTable = true;
            this.loader = true;

            this.actualPage = 0;
            this.totalItems = 0;
            this.payments = [];

            this.$axios.get(`/payments/${this.$route.params.id}?initial_date=${this.filtersData.initial_date}&finish_date=${this.filtersData.finish_date}&items_per_page=${this.itemsPerPage}&page=${this.actualPage + 1}`)
            .then(res => {
                if (!res.data.data) {
                    return this.notify('Ocorreu um erro ao buscar o financeiro do usuário', res.data)
                };
                const data = res.data.data;
                
                this.actualPage += 1;
                
                this.totalItems = data.data.total;
                
                data.data.next_page_url == null ? this.hasNextPage = false : this.hasNextPage = true;
                
                this.totalSumPayments = data.totalSumPayments;

                if (data.totalSumPayments >= 0) {
                    this.totalCreditValue = data.totalCreditValue;
                    this.totalCreditValueMonthly = data.totalCreditValueMonthly;
                    this.totalCreditValueSemiannual = data.totalCreditValueSemiannual;
                    this.totalCreditValueAnnual = data.totalCreditValueAnnual;

                    this.totalMembershipFee = data.totalMembershipFee;

                    this.totalCharges = data.totalCharges;

                    this.totalFees = data.totalFees;
                    
                    this.totalRefundTransfer = data.totalRefundTransfer || 0;
                }
                
                this.financial_situation = data.associate_data.financial_situation;
                this.financial_situation_description = data.associate_data.financial_situation_description;

                this.associate_name = data.associate_data.name;
                this.previousDebts = parseFloat(data.associate_data.previous_debts || 0);
                this.associate_cpf = data.associate_data.document_cpf;
                
                console.log('getNextPaymentFilter - Dados do associado:', data.associate_data);
                console.log('getNextPaymentFilter - paid_for_user_id:', data.associate_data.paid_for_user_id);
                
                // Buscar informações do usuário vinculado
                if (data.associate_data.paid_for_user_id) {
                    console.log('Associado tem usuário vinculado, carregando...');
                    this.loadLinkedUserInfo(data.associate_data.paid_for_user_id);
                } else {
                    console.log('Associado NÃO tem usuário vinculado');
                }

                data.data.data.forEach((item) => {
                    let payments = [];

                    payments.push(item.id); 
                    payments.push(item.payment_method); 
                    payments.push(item.payment_type);
                    payments.push(`${item.payment_date[8]}${item.payment_date[9]}/${item.payment_date[5]}${item.payment_date[6]}/${item.payment_date[0]}${item.payment_date[1]}${item.payment_date[2]}${item.payment_date[3]}`);
                    payments.push(`R$ ${item.credit_value.replace('.', ',')}`);
                    payments.push(`R$ ${item.membership_fee.replace('.', ',')}`);
                    payments.push(`R$ ${item.fees.replace('.', ',')}`);
                    payments.push(`R$ ${item.charges.replace('.', ',')}`);
                    payments.push(`R$ ${(parseFloat(item.credit_value) + parseFloat(item.membership_fee) + parseFloat(item.charges) + parseFloat(item.fees)).toFixed(2).replace(".", ",")}`);
                    payments.push(item.comments);

                    this.payments.push(payments);
                    this.paymentsFullInfos.push(item);
                });

                this.loadingTable = false;
                this.loader = false;
            })
            .catch(err => {
                console.log(err);
                switch (err.response.data.message) {
                    case "Usuário não possui permissões suficientes!":
                        this.$router.push('/inicio');
                        break;
                }
                
                this.notify('Erro ao buscar informações!', 'error');
            })
        },
        getNextPayment() {
            this.loader = true;
            this.loadingTable = true;

            this.$axios.get(`/payments/${this.$route.params.id}?initial_date=${this.filtersData.initial_date}&finish_date=${this.filtersData.finish_date}&items_per_page=${this.itemsPerPage}&page=${this.actualPage + 1}`)
            .then(res => {
                if (!res.data.data) {
                    return this.notify('Ocorreu um erro ao buscar o financeiro do usuário', res.data)
                };
                const data = res.data.data;
                
                this.actualPage += 1;
                
                this.totalItems = data.data.total;
                
                data.data.next_page_url == null ? this.hasNextPage = false : this.hasNextPage = true;
                
                this.totalSumPayments = data.totalSumPayments;

                if (data.totalSumPayments >= 0) {
                    this.totalCreditValue = data.totalCreditValue;
                    this.totalCreditValueMonthly = data.totalCreditValueMonthly;
                    this.totalCreditValueSemiannual = data.totalCreditValueSemiannual;
                    this.totalCreditValueAnnual = data.totalCreditValueAnnual;

                    this.totalMembershipFee = data.totalMembershipFee;

                    this.totalCharges = data.totalCharges;

                    this.totalFees = data.totalFees;
                    
                    this.totalRefundTransfer = data.totalRefundTransfer || 0;
                    
                    this.totalBonusValue = data.totalBonusDiscount || 0;
                }

                this.financial_situation = data.associate_data.financial_situation;
                this.financial_situation_description = data.associate_data.financial_situation_description;

                this.associate_name = data.associate_data.name;
                this.previousDebts = parseFloat(data.associate_data.previous_debts || 0);
                this.associate_cpf = data.associate_data.document_cpf;
                
                console.log('getNextPayment - Dados do associado:', data.associate_data);
                console.log('getNextPayment - paid_for_user_id:', data.associate_data.paid_for_user_id);
                
                // Buscar informações do usuário vinculado
                if (data.associate_data.paid_for_user_id) {
                    console.log('Associado tem usuário vinculado, carregando...');
                    this.loadLinkedUserInfo(data.associate_data.paid_for_user_id);
                } else {
                    console.log('Associado NÃO tem usuário vinculado');
                }

                data.data.data.forEach((item) => {
                    let payments = [];

                    payments.push(item.id); 
                    payments.push(item.payment_method); 
                    payments.push(item.payment_type);
                    payments.push(`${item.payment_date[8]}${item.payment_date[9]}/${item.payment_date[5]}${item.payment_date[6]}/${item.payment_date[0]}${item.payment_date[1]}${item.payment_date[2]}${item.payment_date[3]}`);
                    payments.push(`R$ ${item.credit_value.replace('.', ',')}`);
                    payments.push(`R$ ${item.membership_fee.replace('.', ',')}`);
                    payments.push(`R$ ${item.fees.replace('.', ',')}`);
                    payments.push(`R$ ${item.charges.replace('.', ',')}`);
                    payments.push(`R$ ${(parseFloat(item.credit_value) + parseFloat(item.membership_fee) + parseFloat(item.charges) + parseFloat(item.fees)).toFixed(2).replace(".", ",")}`);
                    payments.push(item.comments);

                    this.payments.push(payments);
                    this.paymentsFullInfos.push(item);
                });

                this.loadingTable = false;
                this.loader = false;
            })
            .catch(err => {
                console.log(err);
                switch (err.response.data.message) {
                    case "Usuário não possui permissões suficientes!":
                        this.$router.push('/inicio');
                        break;
                }
                
                this.notify('Erro ao buscar informações!', 'error');
            })
        },
        openAddPaymentModal(installmentData = null) {
            // Se tiver dados de parcela, preenche o formulário com esses dados
            if (installmentData) {
                this.addPaymentData = {
                    payment_method: '',
                    payment_type: installmentData.payment_type || 'Mensalidade',
                    payment_date: this.getCurrentDate(), // Data atual como padrão
                    credit_value: installmentData.amount || installmentData.credit_value || '',
                    membership_fee: '',
                    charges: '',
                    fees: '',
                    refund_transfer: '',
                    comments: `Pagamento referente à parcela de ${this.getMonthName(installmentData.payment_date)}`,
                    transferred_to_user_id: null,
                    installment_id: installmentData.id, // Vincula o pagamento à parcela
                };
            } else {
                // Reseta o formulário se não houver dados de parcela
                this.addPaymentData = {
                    payment_method: '',
                    payment_type: 'Mensalidade',
                    payment_date: '',
                    credit_value: '',
                    membership_fee: '',
                    charges: '',
                    fees: '',
                    refund_transfer: '',
                    comments: '',
                    transferred_to_user_id: null,
                    installment_id: null,
                };
            }
            
            this.modalAddPayment = true;
        },
        closeAddPaymentModal() {
            this.addPaymentData = {
                payment_method: '',
                payment_type: 'Mensalidade',
                payment_date: '',
                credit_value: '',
                membership_fee: '',
                charges: '',
                fees: '',
                refund_transfer: '',
                comments: '',
                transferred_to_user_id: null,
                installment_id: null,
            };

            this.modalAddPayment = false;
        },
        addPayment() {
            if (
                !this.addPaymentData.payment_method ||
                !this.addPaymentData.payment_type
            ) {
                return this.notify('Preencha todos os dados obrigatórios para adicionar um pagamento!', 'error');
            }

            this.loader = true;

            const paymentData = {
                user_id: parseInt(this.$route.params.id),
                payment_method: this.addPaymentData.payment_method,
                payment_type: this.addPaymentData.payment_type,
                payment_date: this.addPaymentData.payment_date,
                credit_value: parseFloat(this.addPaymentData.credit_value || 0),
                membership_fee: parseFloat(this.addPaymentData.membership_fee || 0),
                charges: parseFloat(this.addPaymentData.charges || 0),
                fees: parseFloat(this.addPaymentData.fees || 0),
                refund_transfer: parseFloat(this.addPaymentData.refund_transfer || 0),
                comments: this.addPaymentData.comments
            };

            // Adiciona installment_id se foi vinculado a uma parcela
            if (this.addPaymentData.installment_id) {
                paymentData.installment_id = this.addPaymentData.installment_id;
            }

            // Adiciona transferred_to_user_id se foi selecionado
            if (this.addPaymentData.transferred_to_user_id) {
                paymentData.transferred_to_user_id = this.addPaymentData.transferred_to_user_id;
            }

            console.log('Enviando pagamento:', paymentData);

            this.$axios.post('/payments', paymentData)
            .then(res => {
                this.notify('Pagamento adicionado com sucesso!', 'success');
                
                // Fecha o modal de adicionar pagamento
                this.closeAddPaymentModal();
                
                // Recarrega os dados da página sem reload completo
                this.actualPage = 0;
                this.payments = [];
                this.paymentsFullInfos = [];
                this.getNextPayment();
                
                // Se o modal da planilha financeira estiver aberto, recarrega as parcelas
                if (this.modalFinancialSpreadsheet) {
                    this.loadingInstallments = true;
                    this.$axios.get(`/installments/associate/${this.$route.params.id}`)
                    .then(res => {
                        this.installments = res.data.data.installments;
                        this.loadingInstallments = false;
                    })
                    .catch(err => {
                        this.loadingInstallments = false;
                    });
                }
                
                this.loader = false;
            })
            .catch(err => {
                console.log('Erro ao adicionar pagamento:', err.response);
                switch (err.response.data.message) {
                    case "Apenas administradores podem tomar essa ação!":
                        this.$router.push('/inicio');
                        break;
                }
                
                this.notify('Erro ao adicionar pagamento!', 'error');
                this.loader = false;
            });
        },
        closeEditPaymentModal() {
            this.editPaymentData = {
                id: null,
                payment_method: '',
                payment_type: '',
                payment_date: '',
                credit_value: '',
                membership_fee: '',
                charges: '',
                fees: '',
                refund_transfer: '',
                comments: '',
                is_previous_debt: 'Não',
                previous_debt_amount: '',
            };

            this.modalEditPayment = false;
        },
        updatePayment() {
            if (
                !this.editPaymentData.payment_method ||
                !this.editPaymentData.payment_type
            ) {
                return this.notify('Preencha todos os dados obrigatórios para editar o pagamento!', 'error');
            }

            // Validar se é débito anterior e tem valor
            if (this.editPaymentData.is_previous_debt === 'Sim' && !this.editPaymentData.previous_debt_amount) {
                return this.notify('Informe o valor do débito anterior!', 'error');
            }

            this.loader = true;

            const paymentData = {
                payment_method: this.editPaymentData.payment_method,
                payment_type: this.editPaymentData.payment_type,
                payment_date: this.editPaymentData.payment_date,
                credit_value: parseFloat(this.editPaymentData.credit_value),
                membership_fee: parseFloat(this.editPaymentData.membership_fee),
                charges: parseFloat(this.editPaymentData.charges),
                fees: parseFloat(this.editPaymentData.fees),
                refund_transfer: parseFloat(this.editPaymentData.refund_transfer || 0),
                comments: this.editPaymentData.comments,
                is_previous_debt: this.editPaymentData.is_previous_debt === 'Sim',
                previous_debt_amount: this.editPaymentData.is_previous_debt === 'Sim' ? parseFloat(this.editPaymentData.previous_debt_amount) : 0
            };

            this.$axios.put(`/payments/${this.editPaymentData.id}`, paymentData)
            .then(res => {
                this.notify('Pagamento atualizado com sucesso!', 'success');

                // Fecha o modal de edição
                this.modalEditPayment = false;
                
                // Recarrega os dados sem reload completo da página
                this.actualPage = 0;
                this.payments = [];
                this.paymentsFullInfos = [];
                this.getNextPayment();
                
                // Recarrega o saldo total do associado
                this.getAssociateBalance();
                
                this.loader = false;
            })
            .catch(err => {
                this.notify(err.response?.data?.message || 'Erro ao atualizar pagamento!', 'error');
                this.loader = false;
            });
        },
        returnToPage() {
            this.$router.push('/associados');
        }
    },
    components: { Head, Table, SimpleModal, Button, Input, Select, Loader }
}
</script>

<template>
    <Loader v-if="loader" />

    <SimpleModal v-if="modalConfirmDelete" @close="modalConfirmDelete = false" title="Deseja deletar?" :hasOkButton="true" okButtonDescription="Confirmar" @clickOkButton="deletePayment">
        <div class="warning-delete-content">
            <h1>Atenção!</h1>

            <p>Essa é uma ação que não pode ser revertida!</p>
            <p>Só delete caso tenha certeza!</p>
            
            <div id="space"></div>
        </div>
    </SimpleModal>

    <section v-if="modalAddPayment" class="bg-add-associate">
        <Head title="Pagamento manual" />

        <div @click="closeAddPaymentModal" class="close-add-associate">
            x
        </div>

        <section class="form-add-associate">
            <div class="form-add-associate-line">
                <Input type="text" label="Meio do crédito*" placeholder="PIX" :value="addPaymentData.payment_method" v-model="addPaymentData.payment_method" />
                <div class="form-add-associate-line-space"></div>
                <Select label="Tipo de pagamento" :options="paymentTypeSelect" :value="addPaymentData.payment_type" v-model="addPaymentData.payment_type" />
                <div class="form-add-associate-line-space"></div>
                <Input type="date" label="Data do pagamento" placeholder="10/01/2023" :value="addPaymentData.payment_date" v-model="addPaymentData.payment_date" />
                <div class="form-add-associate-line-space"></div>
                <Input type="text" label="Contribuição" placeholder="127.90" :value="addPaymentData.credit_value" v-model="addPaymentData.credit_value" :currencyMask="true" />
            </div>

            <div class="form-add-associate-line">
                <Input type="text" label="Taxa de adesão" placeholder="127.90" :value="addPaymentData.membership_fee" v-model="addPaymentData.membership_fee" :currencyMask="true" />
                <div class="form-add-associate-line-space"></div>
                <Input type="text" label="Honorários" placeholder="10/01/2023" :value="addPaymentData.fees" v-model="addPaymentData.fees" :currencyMask="true" />
                <div class="form-add-associate-line-space"></div>
                <Input type="text" label="Encargos" placeholder="127.90" :value="addPaymentData.charges" v-model="addPaymentData.charges" :currencyMask="true" />
                <div class="form-add-associate-line-space"></div>
                <Input type="text" label="Reembolsos/Transferências" placeholder="50.00" :value="addPaymentData.refund_transfer" v-model="addPaymentData.refund_transfer" :currencyMask="true" />
            </div>

            <div class="form-add-associate-line">
                <Input type="text" label="Observações" placeholder="Esse pagamento foi..." :value="addPaymentData.comments" v-model="addPaymentData.comments" />
            </div>

            <div class="form-add-associate-line">
                <Select label="Transferir para usuário (opcional)" :options="transferUserSelect" :value="addPaymentData.transferred_to_user_id" v-model="addPaymentData.transferred_to_user_id" />
            </div>

            <div class="form-add-associate-button">
                <Button type="primary" placeholder="Adicionar pagamento" @buttonPressed="addPayment" />
            </div>
        </section>
    </section>

    <section v-if="modalEditPayment" class="bg-add-associate">
        <Head title="Editar Pagamento" />

        <div @click="closeEditPaymentModal" class="close-add-associate">
            x
        </div>

        <section class="form-add-associate">
            <div class="form-add-associate-line">
                <Input type="text" label="Meio do crédito*" placeholder="PIX" :value="editPaymentData.payment_method" v-model="editPaymentData.payment_method" />
                <div class="form-add-associate-line-space"></div>
                <Select label="Tipo de pagamento" :options="paymentTypeSelect" :value="editPaymentData.payment_type" v-model="editPaymentData.payment_type" />
                <div class="form-add-associate-line-space"></div>
                <Input type="date" label="Data do pagamento" placeholder="10/01/2023" :value="editPaymentData.payment_date" v-model="editPaymentData.payment_date" />
                <div class="form-add-associate-line-space"></div>
                <Input type="text" label="Contribuição" placeholder="127.90" :value="editPaymentData.credit_value" v-model="editPaymentData.credit_value" :currencyMask="true" />
            </div>

            <div class="form-add-associate-line">
                <Input type="text" label="Taxa de adesão" placeholder="127.90" :value="editPaymentData.membership_fee" v-model="editPaymentData.membership_fee" :currencyMask="true" />
                <div class="form-add-associate-line-space"></div>
                <Input type="text" label="Honorários" placeholder="10/01/2023" :value="editPaymentData.fees" v-model="editPaymentData.fees" :currencyMask="true" />
                <div class="form-add-associate-line-space"></div>
                <Input type="text" label="Encargos" placeholder="127.90" :value="editPaymentData.charges" v-model="editPaymentData.charges" :currencyMask="true" />
                <div class="form-add-associate-line-space"></div>
                <Input type="text" label="Reembolsos/Transferências" placeholder="50.00" :value="editPaymentData.refund_transfer" v-model="editPaymentData.refund_transfer" :currencyMask="true" />
            </div>

            <div class="form-add-associate-line">
                <Input type="text" label="Observações" placeholder="Esse pagamento foi..." :value="editPaymentData.comments" v-model="editPaymentData.comments" />
            </div>

            <div class="form-add-associate-line">
                <Select label="É DÉBITO ANTERIOR?" :options="isPreviousDebtSelect" :value="editPaymentData.is_previous_debt" v-model="editPaymentData.is_previous_debt" />
                <div v-if="editPaymentData.is_previous_debt === 'Sim'" class="form-add-associate-line-space"></div>
                <Input v-if="editPaymentData.is_previous_debt === 'Sim'" type="text" label="Valor do Débito Anterior (R$)" placeholder="0.00" :value="editPaymentData.previous_debt_amount" v-model="editPaymentData.previous_debt_amount" :currencyMask="true" />
            </div>

            <div v-if="editPaymentData.is_previous_debt === 'Sim'" class="previous-debt-warning">
                <p>⚠️ <strong>Atenção:</strong> Este valor será deduzido dos débitos anteriores do associado.</p>
            </div>

            <div class="form-add-associate-button">
                <Button type="primary" placeholder="Atualizar pagamento" @buttonPressed="updatePayment" />
            </div>
        </section>
    </section>

    <section class="bg-see-associates">
        <div @click="returnToPage" class="return-to-page">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="icon">
                <path stroke-linecap="round" stroke-linejoin="round" d="M6.75 15.75 3 12m0 0 3.75-3.75M3 12h18" />
            </svg>

            <p>Voltar para a tela de Associados</p>
        </div>

        <Head :title="`Vida Financeira - ${associate_name}`" />

        <section class="filters">
            <Input type="date" label="Desde:" placeholder="10/01/2023" :value="filtersData.initial_date" v-model="filtersData.initial_date" />
            <div class="form-line-space"></div>
            <Input type="date" label="Até:" placeholder="10/01/2023" :value="filtersData.finish_date" v-model="filtersData.finish_date" />
            <div class="form-line-space"></div>
            <Button type="primary" placeholder="Filtrar" class="btn" @buttonPressed="getNextPaymentFilter" />
        </section>

        <p v-if="!loadingTable" id="see-associates-total">Total de pagamentos: <span id="see-associates-total-number">{{ totalItems }}</span></p>
        <p v-if="!loadingTable" id="see-associates-total">Valores pagos por Contribuição: <span id="see-associates-total-number">R$ {{ parseFloat(totalCreditValue).toLocaleString('pt-BR', { minimumFractionDigits: 2 }) }}</span></p>
        <p v-if="!loadingTable" id="see-associates-total">Valores pagos por Contribuição Mensal: <span id="see-associates-total-number">R$ {{ parseFloat(totalCreditValueMonthly).toLocaleString('pt-BR', { minimumFractionDigits: 2 }) }}</span></p>
        <p v-if="!loadingTable" id="see-associates-total">Valores pagos por Contribuição Semestral: <span id="see-associates-total-number">R$ {{ parseFloat(totalCreditValueSemiannual).toLocaleString('pt-BR', { minimumFractionDigits: 2 }) }}</span></p>
        <p v-if="!loadingTable" id="see-associates-total">Valores pagos por Contribuição Anual: <span id="see-associates-total-number">R$ {{ parseFloat(totalCreditValueAnnual).toLocaleString('pt-BR', { minimumFractionDigits: 2 }) }}</span></p>
        <p v-if="!loadingTable" id="see-associates-total">Valores pagos por Taxa de Adesão: <span id="see-associates-total-number">R$ {{ parseFloat(totalMembershipFee).toLocaleString('pt-BR', { minimumFractionDigits: 2 }) }}</span></p>
        <p v-if="!loadingTable" id="see-associates-total">Valores pagos por Honorários: <span id="see-associates-total-number">R$ {{ parseFloat(totalFees).toLocaleString('pt-BR', { minimumFractionDigits: 2 }) }}</span></p>
        <p v-if="!loadingTable" id="see-associates-total">Valores pagos por Encargos: <span id="see-associates-total-number">R$ {{ parseFloat(totalCharges).toLocaleString('pt-BR', { minimumFractionDigits: 2 }) }}</span></p>
        <p v-if="!loadingTable" id="see-associates-total">Valores Reembolsados/Transferidos: <span id="see-associates-total-number">R$ {{ parseFloat(totalRefundTransfer).toLocaleString('pt-BR', { minimumFractionDigits: 2 }) }}</span></p>
        <p v-if="!loadingTable" id="see-associates-total">Valor de Bonificação/Desconto: <span id="see-associates-total-number">R$ {{ parseFloat(totalBonusValue).toLocaleString('pt-BR', { minimumFractionDigits: 2 }) }}</span></p>
        <p v-if="!loadingTable" id="see-associates-total"><strong>VALORES DEVIDOS ANTERIORES:</strong> <span id="see-associates-total-number">R$ {{ parseFloat(previousDebts).toLocaleString('pt-BR', { minimumFractionDigits: 2 }) }}</span></p>
        <p v-if="!loadingTable" id="see-associates-total">Soma total dos valores pagos: <span id="see-associates-total-number">R$ {{ parseFloat(totalSumPayments).toLocaleString('pt-BR', { minimumFractionDigits: 2 }) }}</span></p>
        <p v-if="!loadingTable" id="see-associates-total">Status da vida financeira: <span :class="financial_situation == 'Adimplente' ? 'green' : financial_situation == 'Inadimplente' ? 'red' : ''">{{ financial_situation == 'Adimplente' ? financial_situation : `Pendência - ${financial_situation_description}` }}</span></p>

        <div class="button-add-associate">
            <Button type="primary" @buttonPressed="openAddPaymentModal" placeholder="Adicionar pagamento" />
            <Button type="secondary" @buttonPressed="exportFinancialPDF" placeholder="Exportar PDF financeiro" />
            <Button type="secondary" @buttonPressed="exportFinancialSpreadsheet" placeholder="Planilha financeira" />
        </div>

        <Table v-if="!loadingTable" :hasActions="true" :hasNextPage="hasNextPage" :headers="associateTableCategories" 
        :actions="associatesTableActions" :contents="payments" @loadMore="getNextPayment"
        @clickAction="paymentsTableClickAction" />

        <!-- Modal Planilha Financeira -->
        <section v-if="modalFinancialSpreadsheet" class="bg-spreadsheet-modal">
            <div class="spreadsheet-modal-content">
                <div class="spreadsheet-modal-header">
                    <h2>Planilha Financeira - {{ associate_name }}</h2>
                    <svg @click="closeFinancialSpreadsheetModal" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="close-icon">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
                    </svg>
                </div>

                <Loader v-if="loadingInstallments" />

                <div v-if="!loadingInstallments && installments.length > 0" class="spreadsheet-body">
                    <div class="spreadsheet-info">
                        <p><strong>Ano:</strong> {{ new Date().getFullYear() }}</p>
                        <p><strong>Total de parcelas:</strong> {{ installments.length }}</p>
                    </div>

                    <div class="installments-grid">
                        <div v-for="(installment, index) in installments" :key="installment.id" class="installment-card">
                            <div class="installment-header">
                                <span class="installment-month">{{ getMonthName(installment.payment_date) }}</span>
                                <span :class="['installment-status', getStatusClass(installment)]">
                                    {{ getStatusText(installment) }}
                                </span>
                            </div>
                            <div class="installment-body">
                                <div class="installment-detail">
                                    <span class="label">Vencimento:</span>
                                    <span class="value">{{ formatDate(installment.payment_date) }}</span>
                                </div>
                                <div v-if="installment.paid_at" class="installment-detail">
                                    <span class="label">Data Pagamento:</span>
                                    <span class="value paid-date">{{ formatDate(installment.paid_at) }}</span>
                                </div>
                                <div class="installment-detail">
                                    <span class="label">Tipo:</span>
                                    <span class="value">{{ installment.payment_type }}</span>
                                </div>
                                <div class="installment-detail">
                                    <span class="label">Valor:</span>
                                    <span class="value-amount">R$ {{ formatCurrency(installment.amount || installment.credit_value) }}</span>
                                </div>
                                <div v-if="installment.comments" class="installment-comments">
                                    <span class="label">Obs:</span>
                                    <span class="value">{{ installment.comments }}</span>
                                </div>
                                
                                <!-- Botão para adicionar pagamento para esta parcela -->
                                <div class="installment-action">
                                    <button 
                                        @click="openAddPaymentModal(installment)" 
                                        class="btn-add-payment-installment"
                                        :class="installment.credit_value > 0 ? 'btn-already-paid' : 'btn-pending'"
                                    >
                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="icon-plus">
                                            <path stroke-linecap="round" stroke-linejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
                                        </svg>
                                        {{ installment.credit_value > 0 ? 'Adicionar Outro Pagamento' : 'Adicionar Pagamento' }}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div v-if="!loadingInstallments && installments.length === 0" class="no-installments">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="empty-icon">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M9 12h3.75M9 15h3.75M9 18h3.75m3 .75H18a2.25 2.25 0 0 0 2.25-2.25V6.108c0-1.135-.845-2.098-1.976-2.192a48.424 48.424 0 0 0-1.123-.08m-5.801 0c-.065.21-.1.433-.1.664 0 .414.336.75.75.75h4.5a.75.75 0 0 0 .75-.75 2.25 2.25 0 0 0-.1-.664m-5.8 0A2.251 2.251 0 0 1 13.5 2.25H15c1.012 0 1.867.668 2.15 1.586m-5.8 0c-.376.023-.75.05-1.124.08C9.095 4.01 8.25 4.973 8.25 6.108V8.25m0 0H4.875c-.621 0-1.125.504-1.125 1.125v11.25c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V9.375c0-.621-.504-1.125-1.125-1.125H8.25ZM6.75 12h.008v.008H6.75V12Zm0 3h.008v.008H6.75V15Zm0 3h.008v.008H6.75V18Z" />
                    </svg>
                    <h3>Nenhuma parcela gerada</h3>
                    <p>Ainda não foram geradas parcelas automáticas para este associado.</p>
                </div>
            </div>
        </section>
    </section>
</template>

<style scoped>
.bg-add-associate {
    width: 100%;
    height: 100%;
    position: fixed;
    z-index: 1050;
    top: 0;
    left: 0;
    background-color: white;
    overflow-y: auto;
    padding: 0px 30px;
}

.bg-add-associate .close-add-associate {
    position: absolute;
    top: 22px;
    right: 30px;
    cursor: pointer;
    font-size: 18px;
}

.form-add-associate {
    margin-bottom: 150px;
}

.form-add-associate .form-add-associate-line {
    display: flex;
    align-items: center;
    justify-content: center;
    max-width: 1600px;
    margin: 0px auto;
    margin-bottom: 20px;
}

.form-add-associate .form-add-associate-line .form-add-associate-line-space {
    margin: 0px 10px;
}

.bg-see-associates {
    width: 100%;
    height: auto;
    margin-bottom: 150px;
}

.bg-see-associates #see-associates-total {
    font-size: 18px;
    font-weight: 500;
    color: #2E2E2E;
    margin-bottom: 20px;
}

.bg-see-associates #see-associates-total #see-associates-total-number {
    color: rgb(0, 123, 255);
    font-weight: 600;
}

.form-add-associate-button {
    width: 100%;
}

.button-add-associate {
    display: flex;
    gap: 10px;
    max-width: 100%;
    margin-bottom: 20px;
    flex-wrap: wrap;
}

.associate-infos-simple-modal {
    width: 100%;
}

.associate-infos-simple-modal p {
    font-size: 16px;
    font-weight: 500;
    margin: 5px 0px;
}

.associate-infos-simple-modal span {
    font-weight: 400;
}

.blue {
    color: rgb(12, 121, 198);
    font-weight: 600 !important;
}

.orange {
    color: rgb(230, 149, 0);
    font-weight: 600 !important;
}

.green {
    color: rgb(17, 162, 1);
    font-weight: 600 !important;
}

.red {
    color: rgb(162, 1, 1);
    font-weight: 600 !important;
}

.filters {
    max-width: 300px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    margin-bottom: 20px;
}

.filters .btn {
    margin-top: 25px;
}

.return-to-page {
    display: flex;
    align-items: center;
    cursor: pointer;
}

.return-to-page .icon {
    width: 18px;
    margin-right: 5px;
    color: #baa34f;
    transition: .2s;
}

.return-to-page p {
    font-size: 18px;
    color: #baa34f;
    transition: .2s;
}

.return-to-page:hover .icon {
    color: #b2952d;
    transition: .2s;
}

.return-to-page:hover p {
    color: #b2952d;
    transition: .2s;
}

.warning-delete-content {
    width: 100%;
    text-align: center;
}

.warning-delete-content h1 {
    font-size: 24px;
    color: rgb(255, 61, 61);
    margin-bottom: 20px;
    margin-top: 20px;
}

.warning-delete-content #space {
    margin-bottom: 20px;
}

.warning-delete-content p {
    font-size: 18px;
    margin-bottom: 5px;
}

@media screen and (max-width:800px) {
    .form-add-associate .form-add-associate-line {
        flex-direction: column;
    }

    .form-add-associate .form-add-associate-line-space {
        margin: 10px 0px !important;
    }

    .filters {
        flex-direction: column;
        width: 100%;
        max-width: 100%;
    }

    .filters .btn {
        margin-top: 10px;
    }
}

/* Modal Planilha Financeira */
.bg-spreadsheet-modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 999;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px;
}

.spreadsheet-modal-content {
    background: white;
    border-radius: 12px;
    max-width: 1200px;
    width: 100%;
    max-height: 90vh;
    overflow-y: auto;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
}

.spreadsheet-modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 25px 30px;
    border-bottom: 2px solid #e0e0e0;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: white;
    border-radius: 12px 12px 0 0;
}

.spreadsheet-modal-header h2 {
    margin: 0;
    font-size: 24px;
    font-weight: 600;
}

.close-icon {
    width: 30px;
    height: 30px;
    cursor: pointer;
    transition: transform 0.2s;
}

.close-icon:hover {
    transform: rotate(90deg);
}

.spreadsheet-body {
    padding: 30px;
}

.spreadsheet-info {
    display: flex;
    gap: 30px;
    margin-bottom: 25px;
    padding: 20px;
    background: #f8f9fa;
    border-radius: 8px;
}

.spreadsheet-info p {
    margin: 0;
    font-size: 16px;
    color: #333;
}

.installments-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
    gap: 20px;
}

.installment-card {
    background: white;
    border: 2px solid #e0e0e0;
    border-radius: 10px;
    overflow: hidden;
    transition: all 0.3s;
}

.installment-card:hover {
    transform: translateY(-4px);
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);
    border-color: #667eea;
}

.installment-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: white;
}

.installment-month {
    font-size: 16px;
    font-weight: 600;
}

.installment-status {
    font-size: 12px;
    padding: 4px 12px;
    border-radius: 20px;
    font-weight: 500;
}

.status-paid {
    background: #27ae60;
    color: white;
}

.status-pending {
    background: #f39c12;
    color: white;
}

.status-overdue {
    background: #e74c3c;
    color: white;
}

.installment-body {
    padding: 15px;
}

.installment-detail {
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
    font-size: 14px;
}

.installment-detail .label {
    color: #666;
    font-weight: 500;
}

.installment-detail .value {
    color: #333;
    font-weight: 600;
}

.value-amount {
    color: #667eea;
    font-weight: 700;
    font-size: 16px;
}

.installment-comments {
    margin-top: 15px;
    padding-top: 15px;
    border-top: 1px solid #e0e0e0;
}

.installment-comments .label {
    display: block;
    color: #666;
    font-size: 12px;
    margin-bottom: 5px;
}

.installment-comments .value {
    display: block;
    color: #333;
    font-size: 13px;
    line-height: 1.5;
}

.no-installments {
    text-align: center;
    padding: 60px 30px;
}

.empty-icon {
    width: 80px;
    height: 80px;
    margin: 0 auto 20px;
    color: #ccc;
}

.no-installments h3 {
    margin: 0 0 10px 0;
    font-size: 22px;
    color: #333;
}

.no-installments p {
    margin: 0;
    font-size: 16px;
    color: #666;
}

.previous-debt-warning {
    margin: 15px 0;
    padding: 15px;
    background: #fff3cd;
    border-left: 4px solid #ffc107;
    border-radius: 6px;
}

.previous-debt-warning p {
    margin: 0;
    color: #856404;
    font-size: 14px;
}

.previous-debt-warning strong {
    font-weight: 600;
}

.installment-action {
    margin-top: 15px;
    padding-top: 15px;
    border-top: 1px solid #ecf0f1;
}

.btn-add-payment-installment {
    width: 100%;
    padding: 10px 16px;
    border: none;
    border-radius: 6px;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
}

.btn-add-payment-installment .icon-plus {
    width: 18px;
    height: 18px;
}

.btn-pending {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: white;
}

.btn-pending:hover {
    background: linear-gradient(135deg, #5568d3 0%, #65408b 100%);
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
}

.btn-already-paid {
    background: linear-gradient(135deg, #27ae60 0%, #229954 100%);
    color: white;
}

.btn-already-paid:hover {
    background: linear-gradient(135deg, #229954 0%, #1e8449 100%);
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(39, 174, 96, 0.4);
}

.btn-add-payment-installment:active {
    transform: translateY(0);
}
</style>